export default "__VITE_ASSET__CHSdzGOX__"